// extracted by mini-css-extract-plugin
module.exports = {"content":"post-body_content__oM8Kr"};